import { HttpContextToken } from "@angular/common/http";

// Set on a request's HttpContext to exempt it from the shared interceptor's
// global 401 handling (session-clear + "เซสชันหมดอายุ" dialog + redirect to
// /auth/login, see http-client.intercepter.ts). Some endpoints can return a
// genuine 401 that has nothing to do with the current session being expired
// — e.g. a signed-token verification call, where a 401 means "this token is
// bad/tampered," not "please log in again." Those callers set this token to
// `true` on the request so their own component can render an inline error
// state instead of being clobbered by the global redirect.
export const SKIP_UNAUTHORIZED_HANDLER = new HttpContextToken<boolean>(() => false);
